import { makeStyles } from '@material-ui/core/styles';
import { buttonAddStyles, buttonDeleteStyles } from 'shared/Buttons/button.styles';

export const useListHtmlTemplatesStyles = makeStyles(theme => ({
  htmlTemplates: {
    display: 'flex',
    flexWrap: 'wrap'
  },
  title: {
    margin: '2rem 0 1.5rem 0'
  },
  buttonAdd: {
    ...buttonAddStyles
  },
  buttonDelete: {
    ...buttonDeleteStyles
  }
}));
